import analytics from '../modules/analytics';
import middlewares from '../modules/analytics/middlewares/companyMicrositeApplication';
import 'promise-polyfill/src/polyfill';
import initSentry from '../modules/sentry';
import trackClientEvents from '../modules/trackClientEvents';

analytics.init(middlewares);
analytics.page({}, {
  trackAllPages: true,
});

trackClientEvents();

initSentry('Company Microsite');
